"use client";

import { useReducedMotion } from "framer-motion";
import { useMemo } from "react";

// Shared whileInView reveal for the Google Reviews section — same rise/fade
// pattern as the rest of the 2026 site. Kept local to this folder so the section
// does not couple to another section's helper.
//
// The hidden state must NOT depend on the visitor's motion preference. It is
// what the server writes into the HTML, and the server cannot know that
// preference, so branching it guarantees a hydration mismatch. Reduced motion
// lives in the transition instead: the travel is given zero duration, so the
// element appears in place while the fade still plays.
const HIDDEN = { opacity: 0, y: 24 };

const REDUCED = { opacity: { duration: 0.3 }, y: { duration: 0 } };

export function useReveal({ amount = 0.3 } = {}) {
  const reduce = useReducedMotion();

  const variants = useMemo(
    () => ({
      hidden: HIDDEN,
      show: (i = 0) => ({
        opacity: 1,
        y: 0,
        transition: reduce
          ? REDUCED
          : { duration: 0.55, delay: i * 0.12, ease: "easeOut" },
      }),
    }),
    [reduce],
  );

  return {
    reduce,
    reveal: {
      initial: "hidden",
      whileInView: "show",
      viewport: { once: true, amount },
      variants,
    },
  };
}
